import React, { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';

const QuranAyah = () => {
  const [ayahData, setAyahData] = useState({
    arabic: '',
    translation: '',
    surah: '',
    ayahNumber: '',
  });

  const fetchRandomAyah = async () => {
    try {
      const getRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
      const randomAyahNumber = getRandomNumber(1, 6236);

      const response = await fetch(`https://api.alquran.cloud/v1/ayah/${randomAyahNumber}/editions/quran-uthmani,ur.maududi`);

      if (!response.ok) {
        throw new Error(`Failed to fetch Ayah data: ${response.statusText}`);
      }

      const responseData = await response.json();

      if (!responseData.data || !responseData.data.length) {
        throw new Error('API response structure is not as expected');
      }

      const { text, surah, numberInSurah } = responseData.data[0];

      setAyahData({
        arabic: text,
        translation: responseData.data[1].text, // Assuming Urdu translation is always at index 1
        surah: surah.englishName,
        ayahNumber: numberInSurah,
      });
    } catch (error) {
      console.error('Error fetching Ayah:', error.message);
    }
  };

  useEffect(() => {
    fetchRandomAyah(); // Fetch the first Ayah when the component mounts
  }, []); // Empty dependency array ensures it runs only once on mount

  return (
    <div className="ayah-container" style={{
      width: 'inherit',
      marginRight: '10px',
      marginLeft: '10px',
      backgroundColor: 'darkslategray',
      color: 'white',
      borderRadius: '5px'
    }}>
      <Card className="ayah-content" sx={{
        padding: '16px',
        textAlign: 'center',
        backgroundColor: 'goldenrod',
        color: 'black'
      }}>
        <Typography variant="h4" style={{
          fontFamily: 'Cinzel Decorative',
          fontWeight: 'bold',
          color:'darkslategray'
        }} gutterBottom className="heading">
          Random Ayah, Way to Hidayah
        </Typography>
        <Typography variant="h4" gutterBottom className="arabic-text">
          {ayahData.arabic}
        </Typography>
        <Typography variant="h5" sx={{ fontFamily: 'OpenSans', fontWeight:'lighter' ,color:'white' }} className="translation-text">
          "{ayahData.translation}"
        </Typography>
        <Typography sx={{color:'darkslategray'}} variant="subtitle2" className="surah-info">
          <strong style={{color:'black'}}>Surah: </strong>{ayahData.surah}, <strong style={{color:'black'}}>Ayah: </strong>{ayahData.ayahNumber}
        </Typography>
      </Card>
    </div>
  );
};

export default QuranAyah;
